import { createContext, useContext } from 'react';

import { FeaturesSettings } from '../../types/siteSettings';

export const FeaturesContext = createContext<FeaturesSettings>({});

export const useEnabledFeatures = () => {
  return useContext(FeaturesContext);
};
